import { useQuery } from '@tanstack/react-query';
import { KnowledgeFileSearchResult } from '../../interfaces/Knowledge';
import { searchKnowledgeFiles } from '../../services/knowledgeService';

// Same minimum as the backend's search_files endpoint, which rejects shorter queries
export const KNOWLEDGE_FILE_SEARCH_MIN_LENGTH = 2;

// Files of a knowledge base whose text literally contains `query`, best first
export const useKnowledgeFileSearch = (
  knowledgeId: string | undefined,
  query: string
) => {
  const trimmedQuery = query.trim();

  return useQuery<KnowledgeFileSearchResult[], Error>({
    queryKey: ['knowledge-file-search', knowledgeId, trimmedQuery],
    queryFn: async () => {
      const result = await searchKnowledgeFiles(
        knowledgeId as string,
        trimmedQuery
      );
      return (result?.message ?? []) as KnowledgeFileSearchResult[];
    },
    enabled:
      !!knowledgeId && trimmedQuery.length >= KNOWLEDGE_FILE_SEARCH_MIN_LENGTH,
    staleTime: 60 * 1000, // files change on save, a minute is enough for retyping
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
